import { View } from 'react-native';

export const AnimatedOfferItem = View;
